import { Box, MenuItem, Select, Typography, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { DeviceService } from "../../../../services/DataService";
import { TestCasesContainer } from "../../../../components/Test/TestCasesContainer";
import { Translate } from "react-i18nify";
import { useNavigate, useParams } from "react-router-dom";
import PageContainer from "../../../../components/PageContainer";
import { PageHeader } from "../../../../components/Layout/PageHeader";
import { DEVICE_TYPE } from "../../Production";
import { PROTOCOL_SCOPE } from "../../../UploadTraceProtocol/UploadTraceProtocol";

export const DeviceTestPage = () => {
    const { udsn, type } = useParams();

    const navigate = useNavigate();
    const [testProtocols, setTestProtocols] = useState([])
    const [selectedTP, setSelectedTP] = useState(null)
    const [confirmRedirect, setConfirmRedirect] = useState(false)

    useEffect(() => {
        (async () => {
            if(type){
                let scope = [PROTOCOL_SCOPE.UNIVERSAL]
                scope.push(getScopeByType(type))
                await DeviceService.getTestProtocols(scope).then(res => {
                // await DeviceService.getTestProtocols(type).then(res => {
                    setTestProtocols(res.data)
                }).catch(e => {
                    console.error(e)
                })
            }
        })();
    },[type])

    useEffect(() => {
        if(confirmRedirect){
            navigate(`/production/${type}`);
        }
    },[confirmRedirect])
    
    const handleTPSelect = (event) => {
        const newValue = event.target.value
        setSelectedTP(newValue)
    }

    return(
        <PageContainer> 
            <PageHeader leftAlign>
            <Translate value="Test" />
            </PageHeader>
            <Typography sx={{ mt: 1, mb: 1 }} variant="h5">
            <Translate value="TestingDeviceWithUDSN" />: {udsn}
            </Typography>
        <Box id="DeviceTestPage" sx={{ width:"40%" }}  >
            <Box sx={{ bgcolor:'notify.warning', borderRadius:"10px", width:"120%", height: 50, mt:1, mb:2, alignContent:"center" }} >
                <Typography variant="h6" sx={{ alignContent:"center", ml:1.5}} >
                    <Translate value="CheckDocumentId"  /> 
                            
                </Typography>
            </Box>

            {
                testProtocols.length < 0 ?
                <></>
                :
                <Box>
                    <Box id="TestProtocolDropDownContainer" >
                        <Select
                            required
                            id="testProtocolsSelect"
                            displayEmpty
                            value={selectedTP || ""}
                            onChange={handleTPSelect}
                            sx={{
                                width: "fit-content" //{md: 800}
                            }}
                        >
                            <MenuItem value={""}><Translate value="SelectTestProtocol" /></MenuItem>
                            {
                                testProtocols.map((val,key) => {
                                    return <MenuItem key={key} value={val}>{val.fileName}</MenuItem>
                                })
                            }
                        </Select>
                    </Box>
                </Box>
            }
            {
                selectedTP == null ?
                <></>
                :
                <Box id="TestCaseContainer" >
                    <TestCasesContainer udsn={udsn} testProtocol={selectedTP} setConfirmRedirect={setConfirmRedirect} deviceType={type} />
                </Box>
            }
        </Box>
        </PageContainer>
    )
}

export const getScopeByType = (type) => {
    if(type === DEVICE_TYPE.HOT.code)
        return "HOT"
    else if(type === DEVICE_TYPE.PRO100.code)
        return "PRO"
}